import ScrollMagic from "scrollmagic";
import SimulationLink from "../components/SimulationLink";
import {isElementXPercentInViewport} from "../../helpers/tools";
import SimulationProgress from "../components/SimulationProgress";
import {resetScrollConfig, scrollConfig} from "../helpers/tools";

export default {
  mounted() {
    this.pinSlide();
    this.scrollSlideIntoView();
  },

  beforeDestroy() {
    resetScrollConfig()
  },

  methods: {
    /**
     *
     */
    scrollSlideIntoView() {
      const el = document.querySelector("#slide-container");
      if (el && !isElementXPercentInViewport(el, 50)) {
        el.scrollIntoView();
      }
    },

    /**
     *
     */
    pinSlide() {
      const el = document.querySelector("#scroll-target");
      if (el.scrollHeight > el.clientHeight) {
        const triggerElement = document.querySelector("#slide-container");
        scrollConfig.controller = new ScrollMagic.Controller();
        scrollConfig.scene = new ScrollMagic
          .Scene({
            triggerHook: 0,
            triggerElement,
            duration: el.scrollHeight - el.clientHeight,
          })
          .setPin(triggerElement)
          .on("progress", (e) => {
            this.scrollToPercent(
              e.progress.toFixed(3)
            )
          })
          .addTo(scrollConfig.controller)
      }
    },

    /**
     *
     * @param percent
     */
    scrollToPercent(percent) {
      const el = document.querySelector("#scroll-target");
      const scrollableHeight = el.scrollHeight - el.clientHeight;
      el.scrollTop = percent * scrollableHeight;
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <div id="slide-container" class="pb-6 relative max-h-screen flex flex-col">
        <div class="p-3 pb-1 lg:pb-3 lg:px-0 lg:w-11/12 lg:mx-auto">
          <div class="flex flex-row h-full w-full items-center lg:justify-between whitespace-no-wrap">
            <div class="flex flex-1 lg:w-auto flex-wrap">
              <SimulationLink
                to="what-to-do"
                children={(
                  <span class="transform scale-90 lg:scale-100">what to do</span>
                )}
                activeClassName="bg-brand-blue-500"
                class="mb-2 lg:mb-0 mr-2 lg:mr-3 bg-brand-gray-500 rounded-full px-1 py-2 lg:px-6 uppercase text-white text-xs lg:text-sm focus:outline-none flex items-center"
              />
              <SimulationLink
                to="case-study"
                children={(
                  <div class="flex items-center transform scale-90 lg:scale-100">
                    <img src="/img/changemanagement/icn-case-study.svg" alt="" class="w-4 lg:w-6 mr-1"/>
                    case study
                  </div>
                )}
                activeClassName="bg-brand-blue-500"
                class="mb-2 lg:mb-0 mr-2 lg:mr-3 lg:ml-auto bg-brand-gray-500 rounded-full px-1 py-2 lg:px-2 xl:px-6 uppercase text-white text-xs xl:text-sm flex items-center focus:outline-none"
              />
              <SimulationLink
                to="stakeholders"
                children={(
                  <div class="flex items-center transform scale-90 lg:scale-100">
                    <img src="/img/changemanagement/icn-stakeholders.svg" alt="" class="w-4 lg:w-6 mr-1"/>
                    stakeholders
                  </div>
                )}
                activeClassName="bg-brand-blue-500"
                class="mb-2 lg:mb-0 mr-2 lg:mr-3 bg-brand-gray-500 rounded-full px-1 py-2 lg:px-6 uppercase text-white text-xs lg:text-sm flex items-center focus:outline-none"
              />
              <SimulationLink
                to="take-action"
                children={(
                  <div class="flex items-center transform scale-90 lg:scale-100">
                    <img src="/img/changemanagement/icn-take-action.svg" alt="" class="w-4 lg:w-6 mr-1"/>
                    take action
                  </div>
                )}
                activeClassName="bg-brand-blue-500"
                class="mb-2 lg:mb-0 bg-brand-gray-500 rounded-full px-1 py-2 lg:px-6 uppercase text-white text-xs lg:text-sm flex items-center focus:outline-none"
              />
            </div>
            <div class="hidden lg:block lg:w-5 xl:w-20"></div>
            <SimulationProgress/>
          </div>
        </div>

        <div id="scroll-target" class="shadow-md mx-3 lg:mx-6 bg-white rounded flex-1 overflow-hidden">
          { this.$slots.default }
        </div>

        <portal-target name="modals">
        </portal-target>
      </div>
    );
  }
}
